import { render, staticRenderFns } from "./dropdown-popper-wrapper.vue?vue&type=template&id=038af0cd"
import script from "./dropdown-popper-wrapper.vue?vue&type=script&lang=js"
export * from "./dropdown-popper-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports